import React, { useState, useEffect } from "react";
import axios from "axios";
import Header from "./components/header";
import Footer from "./components/footer";
import { Link } from "react-router-dom";

const BannedList = () => {
  const [bannedList, setBannedList] = useState([]);
  const [input, setInput] = useState("");

  const addBannedItem = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(
        "https://westandwithgaza.com/api/add-banned-item",
        { name: input }
      );
      fetchBannedItems();
      setInput("");
    } catch (err) {
      console.error(err);
    }
  };

  const removeBannedItem = async (name) => {
    try {
      await axios.post(`https://westandwithgaza.com/api/remove-banned-item/`, {
        name: name,
      });
      fetchBannedItems();
    } catch (err) {
      console.error(err);
    }
  };

  const fetchBannedItems = async () => {
    try {
      axios
        .get("https://westandwithgaza.com/api/get-banned-item")
        .then((res) => {
          console.log(res.data);
          setBannedList(res.data.data);
        });
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchBannedItems();
  }, []);

  return (
    <div className="bg-gray-100 min-h-screen flex flex-col">
      <Header />

      <div className="w-screen flex-1 mx-auto mt-2 lg:w-2/4 xl:w-2/4">
        <div className="flex justify-between items-center flex-col sm:flex-row">
          <div className="text-3xl m-4">Banned Products List</div>
          <Link
            to={"/unknown-list"}
            className="bg-black text-white h-min py-4 px-6 rounded hover:text-white hover:no-underline"
          >
            Go to Request List
          </Link>
        </div>
        <form onSubmit={addBannedItem} className="p-4">
          <input
            type="text"
            className="border-2 border-gray-300 p-2 w-full"
            placeholder="Add new item to banned list"
            value={input}
            onChange={(e) => setInput(e.target.value)}
          />
          <button
            type="submit"
            className="bg-blue-500 text-white px-4 py-4 mt-2 rounded"
          >
            Add item
          </button>
        </form>
        <div className="p-4 rounded">
          {bannedList.map((item, index) => (
            <div key={item._id} className="flex bg-white mb-1 p-2 rounded">
              <div className={`text-gray-700 flex items-center w-14`}>
                {index + 1}
              </div>
              <div className={`text-gray-700 flex items-center`}>
                {item.name}
              </div>
              <button
                className="bg-red-500 text-white px-4 py-2 rounded ml-auto"
                onClick={() => removeBannedItem(item.name)}
              >
                Delete
              </button>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default BannedList;
